import React from 'react';
import {
  useColorModeValue } from "./ui/color-mode";
import { Link as RouterLink } from 'react-router-dom';
import { Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Button,
  Icon,
} from '@chakra-ui/react';
import { Avatar } from '@/components/ui/avatar';
import { FaArrowLeft, FaMapMarkerAlt } from 'react-icons/fa';
import Footer from './Footer';
import SEO from './SEO.jsx';

const SobreNosotros = () => {
  const teamMembers = [
    {
      name: 'Elio Muñóz',
      location: 'Málaga, España',
      role: 'Co-fundador',
      bio: 'Bioquímico, técnico de sostenibilidad en el sector Agroganadero y compositor musical.',
      avatar: '/assets/us1.png',
    },
    {
      name: 'Marco Muñóz',
      location: 'Málaga, España',
      role: 'Co-fundador',
      bio: 'Full-Stack Developer y co-fundador de Databay Solutions.',
      avatar: '/assets/us2.png',
    },
    {
      name: 'Miguel Parra',
      location: 'Jaén, España',
      role: 'Co-fundador',
      bio: 'Full-Stack Developer y Musicólogo.',
      avatar: '/assets/us3.png',
    },
  ];

  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <SEO
        title="Sobre Nosotros"
        description="El equipo de Cadencya. Sistema para el día a día de las bandas y comunidad para hermandades."
        path="/sobre-nosotros"
      />
      {/* Header con botón de volver */}
      <Box bg="purple.600" color="white" py={6}>
        <Container maxW="7xl">
          <Button
            variant="ghost"
            color="white"
            _hover={{ bg: 'purple.700' }}
            mb={4}
            asChild><RouterLink to="/"><Icon asChild><FaArrowLeft /></Icon>Volver al inicio
                                    </RouterLink></Button>
          <Heading size="2xl" mb={4}>
            Sobre Nosotros
          </Heading>
          <Text fontSize="xl" maxW="3xl">
            Somos un equipo de músicos y desarrolladores. Construimos el sistema
            del día a día de la agrupación y, también, la comunidad entre bandas y hermandades.
          </Text>
        </Container>
      </Box>

      {/* Contenido principal */}
      <Box flex="1" bg={bgColor} py={16}>
        <Container maxW="7xl">
          {/* Misión */}
          <VStack gap={6} mb={16} textAlign="center" maxW="4xl" mx="auto">
            <Heading size="lg" color="purple.600">
              Nuestra Misión
            </Heading>
            <Text fontSize="lg" color="gray.700">
              Cadencya existe para que una banda gestione plantilla, partituras,
              ensayos, actuaciones y su web pública en un solo sitio. La comunidad
              con hermandades y entidades sigue ahí, como segundo producto.
            </Text>
            <Text fontSize="md" color="gray.600">
              Creemos en la tradición y en herramientas claras para el día a día
              de la agrupación. Por eso el producto crece primero en Gestión, Archivo y Tu Web.
            </Text>
          </VStack>

          {/* Equipo */}
          <Heading size="lg" color="purple.600" textAlign="center" mb={12}>
            Conoce al Equipo
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} gap={10}>
            {teamMembers.map((member, index) => (
              <Box
                key={index}
                bg={cardBg}
                p={8}
                rounded="2xl"
                shadow="lg"
                textAlign="center"
                transition="transform 0.3s"
                _hover={{ transform: 'translateY(-5px)', shadow: 'xl' }}
              >
                <VStack gap={4}>
                  <Avatar.Root size="2xl" bg="purple.500"><Avatar.Fallback name={member.name} /><Avatar.Image src={member.avatar} /></Avatar.Root>
                  <VStack gap={1}>
                    <Heading size="md">{member.name}</Heading>
                    <Text color="purple.600" fontWeight="600">
                      {member.role}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      <Icon mr={1} asChild><FaMapMarkerAlt /></Icon>
                      {member.location}
                    </Text>
                  </VStack>
                  <Text color="gray.600" textAlign="justify">
                    {member.bio}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>

          {/* Valores */}
          <Box mt={20} textAlign="center">
            <Heading size="lg" color="purple.600" mb={8}>
              Nuestros Valores
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 3 }} gap={8} maxW="5xl" mx="auto">
              <VStack
                bg={cardBg}
                p={6}
                rounded="xl"
                shadow="md"
              >
                <Heading size="md" color="purple.600">
                  🎺 Tradición
                </Heading>
                <Text color="gray.600">
                  Respetamos y valoramos las costumbres de la Semana Santa
                </Text>
              </VStack>
              <VStack
                bg={cardBg}
                p={6}
                rounded="xl"
                shadow="md"
              >
                <Heading size="md" color="purple.600">
                  🤝 Transparencia
                </Heading>
                <Text color="gray.600">
                  Facilitamos la comunicación clara y directa entre todos
                </Text>
              </VStack>
              <VStack
                bg={cardBg}
                p={6}
                rounded="xl"
                shadow="md"
              >
                <Heading size="md" color="purple.600">
                  💡 Innovación
                </Heading>
                <Text color="gray.600">
                  Usamos tecnología moderna para mejorar procesos tradicionales
                </Text>
              </VStack>
            </SimpleGrid>
          </Box>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};

export default SobreNosotros;
